import { BodyHeavy as o } from "../../../../styles/typography/index.js";
import { css as t, styled as e } from "styled-components";
import { Theme as r } from "../../../../styles/themes/index.js";
const i = 1.25, n = t`
  --lines: 2;
  --fontsize: 1rem;
  --lineHeight: ${i}rem;
  font-size: var(--fontsize);
  line-height: var(--lineHeight);
  max-height: calc(var(--lineHeight) * var(--lines));
  -webkit-line-clamp: var(--lines);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-wrap: break-word;
`, d = e.div`
  max-height: auto;
  &[aria-expanded='false'] {
    ${n}
  }
`, c = e.button`
  ${o}
  color: rgb(${r.colors.Brand});
  text-align: left;
  cursor: pointer;
  background: transparent;
`, p = e.div`
  box-sizing: border-box;
  overflow: hidden;
  margin-top: 8px;
`, m = e.div``;
export {
  m as Container,
  p as ImgWrapper,
  i as LINE_HEIGHT,
  c as ReadMore,
  d as RetractText
};
